import React, { useState } from 'react';
import BottomMenuBar from './BottomMenuBar';
import EmailForm from './EmailForm';
import BackArrow from './BackArrow';
import mekong from '../images/mekong.jpg';
import me from '../images/me_casual.jpg';

function AboutMe() {
  const [isEmailVisible, setisEmailVisible] = useState(false);
  const toggleEmailVisibility = () => {
    setisEmailVisible(!isEmailVisible);
  };

  return (
    <div className="about-page" style={{ backgroundImage: `url(${mekong})` }}>
      <BackArrow />
      <h1 className="about-heading">About Me</h1>
      <div className="about-card">
        <div className="about-avatar">
          <img
            src={me}
            alt="Axel"
            style={styles.image}
          />
        </div>

        <p className="about-text">
          Hi there! I’m Axel. I am currently based in London, where I am pursuing an MSc in Management of Information Systems and Digital Innovation at the London School of Economics.
        </p>
        <p className="about-text">
          What drives me is steering digital change: understanding how technology reshapes organisations, and helping people and businesses get real value out of it. Before LSE I worked as a consultant at HiQ in Stockholm, with clients in the infrastructure, defence and transportation sectors, where I learned how much a successful project depends on clear communication and on bringing the right people together.
        </p>
        <p className="about-text">
          I graduated from Middlebury College in 2023 with a degree in Computer Science and a minor in English Literature. When I’m not studying, you can find me enjoying the great outdoors, exercising or traveling. Thanks for stopping by!
        </p>
      </div>
      {isEmailVisible && <EmailForm onClose={toggleEmailVisibility} />}
      <BottomMenuBar onShowBox={toggleEmailVisibility}/>
    </div>
  );
}

// Layout styles live in global.css, since they change on small screens
const styles = {
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
};


export default AboutMe;
